module.exports = __webpack_public_path__ + "static/img/open_member_vip_bg_n.953db87.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/open_member_vip_bg_n.png
// module id = 9ylp
// module chunks = 1